import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { Header } from '../Header';
import { GeneralChart } from '../GeneralChart';

import {
  ConsolidatedPaperContainer,
  ConsolidatedPaperHeader,
  ConsolidatedPaperBody,
  ChartArea,
  LabelChartAligment,
  LegendRow,
  WarningLabel,
} from './styles';
import { BlipLoadingComponent } from '../../../../../components/BlipLoading/BlipLoadingComponent';
const ConsolidatedPaperCenterComponent = ({ header, chart, infoPapers, isLoading }) => {
  const LabelChart = useMemo(() => {
    return chart.chartData.customLabels.map((label) => {
      const labelKey = `${label.text}-${label.backgroundColor}`;
      return (
        <LabelChartAligment key={labelKey} backgroundColor={label.backgroundColor}>
          <BdsTypo key={labelKey} variant={'fs-14'} bold={'regular'} lineHeight="plus">
            {label.text}
          </BdsTypo>
        </LabelChartAligment>
      );
    });
  }, [chart]);

  return (
    <ConsolidatedPaperContainer>
      <ConsolidatedPaperHeader>
        <Header
          title={header.title}
          subtitle={header.subtitle}
          period={header.period}
          learnMore={header.learnMore}
          modalContent={header.modalContent}
          tooltipIcon={header.tooltipIcon}
          tooltipText={header.tooltipText}
          buttonTitle={header.buttonTitle}
          pathname={header.pathname}
          buttonTrackEvent={header.buttonTrackEvent}
          tooltipTrackEvent={header.tooltipTrackEvent}
          idTest={header.idTest}
          hasModalWithAccordion={header.hasModalWithAccordion}
          accordionData={header.accordionData}
        />
      </ConsolidatedPaperHeader>

      <ConsolidatedPaperBody>
        {isLoading ? (
          <BlipLoadingComponent />
        ) : (
          <>
            <BdsTypo variant="fs-20" bold="bold" lineHeight="plus">
              {infoPapers.headerTitle}
            </BdsTypo>
            {infoPapers.content}
            
            <ChartArea>
              <BdsTypo variant="fs-20" bold="bold" lineHeight="plus">
                {chart.chartData.title}
              </BdsTypo>

              <GeneralChart
                chartType={chart.chartData.chartType}
                data={chart.chartData}
                options={chart.chartOptions}
                redraw={false}
              />

              <LegendRow>{LabelChart}</LegendRow>

              {chart.chartData.warningLabelBold && chart.chartData.warningLabelRegular && (
                <WarningLabel>
                  <BdsTypo variant="fs-14" bold="regular" lineHeight="plus">
                    <span>{chart.chartData.warningLabelBold}</span>
                    <span>{chart.chartData.warningLabelRegular}</span>
                  </BdsTypo>
                </WarningLabel>
              )}
            </ChartArea>
          </>
        )}
      </ConsolidatedPaperBody>
    </ConsolidatedPaperContainer>
  );
};

ConsolidatedPaperCenterComponent.propTypes = {
  header: PropTypes.object.isRequired,
  chart: PropTypes.object.isRequired,
  infoPapers: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};

export { ConsolidatedPaperCenterComponent };
